import * as actionType from "../constants/actionTypes";

const initialState = {
  favorites: [],
  loading: false,
  error: null,
  responseMessage: "",
};

const favoriteReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionType.TOGGLE_FAVORITE:
      return {
        ...state,
        loading: false,
        error: null,
        responseMessage: action.payload?.content || "Favorite saved",
      };

    case actionType.FETCH_FAVORITE_INVENTORY:
      return {
        ...state,
        favorites: action.payload?.content || [],
        loading: false,
        error: null,
      };

    case actionType.DELETE_FAVORITES: {
      const inventoryToDelete = action.payload?.name;

      const updatedFavorites = state.favorites
        .map((fav) => {
          if (fav.inventory_name === inventoryToDelete) {
            return {
              ...fav,
              inventory_hosts: [],
            };
          }
          return fav;
        })
        .filter((fav) => fav.inventory_hosts.length > 0); // remove inventories with no hosts

      return {
        ...state,
        favorites: updatedFavorites,
        loading: false,
        error: null,
        responseMessage:
          action.payload?.content || "Favorite inventory deleted successfully",
      };
    }

    default:
      return state;
  }
};

export default favoriteReducer;
